const CACHE_CLEARED_MESSAGE_MANUALLY = 'cache is cleared! ;) manually';
const CACHE_CLEARED_MESSAGE_ERROR =
  'cache is cleared! ;) error with RC occurred';
const CACHE_CLEARED_MESSAGE_VERSIONS =
  'cache is cleared! ;) versions are different';
const CACHE_NOT_CLEARED_MESSAGE = 'cache is NOT cleared ;(';

export const cacheConfig = {
  CACHE_CLEARED_MESSAGE_ERROR,
  CACHE_CLEARED_MESSAGE_MANUALLY,
  CACHE_CLEARED_MESSAGE_VERSIONS,
  CACHE_NOT_CLEARED_MESSAGE,
};
